// Shared transaction history filter dropdown options (values must match list filter logic).
export const TRANSACTION_HISTORY_FILTER_TYPE_OPTIONS = [
  { value: "all", label: "All Types" },
  { value: "buy", label: "Buy" },
  { value: "sell", label: "Sell" },
  { value: "deposit", label: "Deposit" },
  { value: "withdrawal", label: "Withdrawal" },
  { value: "send", label: "Send" },
  { value: "receive", label: "Receive" },
  { value: "incoming", label: "Incoming" },
  { value: "outgoing", label: "Outgoing" },
];

export const TRANSACTION_HISTORY_FILTER_STATUS_OPTIONS = [
  { value: "all", label: "All Statuses" },
  { value: "complete", label: "Complete" },
  { value: "pending", label: "Pending" },
  { value: "awaiting settlement", label: "Awaiting Settlement" },
];
